export default __webpack_public_path__ + "e446fdf553aa5ffe4262d49aa5576f80.png";